import controller from './payment-history.controller';

import templateBase from './templates/payment-history.view.html';
import adaptativo from './templates/payment-history-adaptativo.view.html';

let ReportPaymentHistoryComponent = {
  template: changeTemplate,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate() {
  if(__env.adaptative){
    return adaptativo;
  } else {
    return templateBase;
  }
}


export default ReportPaymentHistoryComponent;



/** WEBPACK FOOTER **
 ** ./www/components/reports/payment-history/payment-history.component.js
 **/